import { AudioWithControls } from './components/AudioWithControls';
import { ContentImage } from './components/ContentImage';
import { MediaPlayerControls } from './components/MediaPlayerControls';
import { RecordButton } from './components/RecordButton';
import { SpeakerAndProgressButton } from './components/SpeakerAndProgressButton';
import { SpeechButton } from './components/SpeechButton';
import { SpeechButtonSimple } from './components/SpeechButtonSimple';
import { VideoWithControls } from './components/VideoWithControls';
import { mediaActions, mediaReducer, mediaSelectors } from './redux/media-reducer';
import { mediaSagas } from './redux/media-sagas';
import { AudioPlayer } from './utils/AudioPlayer';
import { stopAllMedia } from './utils/media-stopping-utils';
import { getUrnFromContent, IMAGE_SIZE, MEDIA_TYPE, parseMediaContent, initAudioAutoplayWorkaround, getSortedLinesFromTranscript } from './utils/media-utils';
import { SREPlayer } from './utils/SREPlayer';
import { withAudioParsing } from './utils/withAudioParsing';

var exportedMediaActions = {
  initializeMediaLib: mediaActions.initializeMediaLib,
  resetToInitialState: mediaActions.resetToInitialState,
  loadDecryptionKeys: mediaActions.loadDecryptionKeys,
  setRecordingStarted: mediaActions.startRecorderRecording,
  setRecordingStopped: mediaActions.stopRecorderRecording
};

var exportedMediaSelectors = {
  isRecording: mediaSelectors.isRecording
};

export { exportedMediaActions as mediaActions, exportedMediaSelectors as mediaSelectors, mediaReducer, mediaSagas, getUrnFromContent, parseMediaContent, initAudioAutoplayWorkaround, getSortedLinesFromTranscript, stopAllMedia, MEDIA_TYPE, IMAGE_SIZE, AudioPlayer, AudioWithControls, ContentImage, MediaPlayerControls, RecordButton, SpeakerAndProgressButton, SpeechButton, SpeechButtonSimple, SREPlayer, VideoWithControls, withAudioParsing };